import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Pmain from '../views/Main.vue'
import Program from '../views/Program.vue'
import Conntect from '../views/Conntect.vue'
import News from '../views/News.vue'
import NewsInfo from '../views/NewsInfo.vue'
import Gsxx from '../views/Conntect/Gsxx.vue'
import Czlc from '../views/Conntect/Czlc.vue'
import Lxwm from '../views/Conntect/Lxwm.vue'
import Zzjg from '../views/Conntect/Zzjg.vue'
import Jgjj from '../views/Conntect/Gsxx/Jgjj.vue'
import Zjgw from '../views/Conntect/Gsxx/Zjgw.vue'
import Zc from '../views/Conntect/Gsxx/Zc.vue'
import Lsh from '../views/Conntect/Gsxx/Lsh.vue'
import Frdjz from '../views/Conntect/Gsxx/Frdjz.vue'
import Lszjj from '../views/Conntect/Gsxx/Lszjj.vue'
import ZjgwContent from '../views/Conntect/Gsxx/ZjgwContent.vue'
import Zcfg from '../views/NewsInfo/Zcfg.vue'
import Glzd from '../views/NewsInfo/Glzd.vue'
import Ndbg from '../views/NewsInfo/Ndbg.vue'
import Sjbg from '../views/NewsInfo/Sjbg.vue'
import Xxgg from '../views/NewsInfo/Xxgg.vue'
import Hydt from '../views/News/Hydt.vue'
import Xmdt from '../views/News/Xmdt.vue'
import Jgdt from '../views/News/Jgdt.vue'
import NewsContent from '../views/News/NewsContent.vue'
import InfoContent from '../views/NewsInfo/InfoContent.vue'
import Jlzx from '../views/Jlzx.vue'
import Lyb from '../views/Jlzx/Lyb.vue'
import Wtjd from '../views/Jlzx/Wtjd.vue'
import Hzzx from '../views/Hzzx.vue'
import Hzms from '../views/Jlzx/Hzms.vue'
import Xmjz from '../views/Hzzx/Xmjz.vue'
import Hdzs from '../views/News/Hdzs.vue'
import Search from '../views/Search.vue'
import Computions from '../views/Computions.vue'
import HdzsContent from '../views/Hdzs/HdzsContent.vue'
import NotFount from '../views/404.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import ProgramDetail from '../views/ProgramDetail.vue'
import Cms from '../views/User/Cms.vue'
import UserInfo from '../views/User/UserInfo.vue'
import pMyProgram from '../views/User/MyProgram.vue'
import Xxwh from '../views/User/Xxwh.vue'
import JzList from '../views/User/JzList.vue'
import SzList from '../views/User/SzList.vue'
import UploadMyProgram from '../views/User/UploadMyProgram.vue'
import EditMyProgram from '../views/User/EditMyProgram.vue'

import mMain from '../views/mMain.vue'
import mHome from '../views/mHome.vue'
import mNews from '../views/mNews.vue'
import mNewsContent from '../views/mNews/NewsContent.vue'
import mHydt from '../views/mNews/Hydt.vue'
import mXmdt from '../views/mNews/Xmdt.vue'
import mJgdt from '../views/mNews/Jgdt.vue'
import mHdzs from '../views/mNews/Hdzs.vue'
import mJlzx from '../views/mJlzx.vue'
import mLyb from '../views/mJlzx/Lyb.vue'
import mWtjd from '../views/mJlzx/Wtjd.vue'
import mHzms from '../views/mJlzx/Hzms.vue'
import mConntect from '../views/mConntect.vue'
import mGsxx from '../views/mConntect/Gsxx.vue'
import mCzlc from '../views/mConntect/Czlc.vue'
import mLxwm from '../views/mConntect/Lxwm.vue'
import mZzjg from '../views/mConntect/Zzjg.vue'
import mJgjj from '../views/mConntect/Gsxx/Jgjj.vue'
import mZjgw from '../views/mConntect/Gsxx/Zjgw.vue'
import mZc from '../views/mConntect/Gsxx/Zc.vue'
import mLsh from '../views/mConntect/Gsxx/Lsh.vue'
import mFrdjz from '../views/mConntect/Gsxx/Frdjz.vue'
import mLszjj from '../views/mConntect/Gsxx/Lszjj.vue'
import mZjgwContent from '../views/mConntect/Gsxx/ZjgwContent.vue'
import mNewsInfo from '../views/mNewsInfo.vue'
import mZcfg from '../views/mNewsInfo/Zcfg.vue'
import mGlzd from '../views/mNewsInfo/Glzd.vue'
import mNdbg from '../views/mNewsInfo/Ndbg.vue'
import mSjbg from '../views/mNewsInfo/Sjbg.vue'
import mXxgg from '../views/mNewsInfo/Xxgg.vue'
import mInfoContent from '../views/mNewsInfo/InfoContent.vue'
import mProgram from '../views/mProgram.vue'
import mProgramContent from '../views/mProgramContent.vue'
import mHzzx from '../views/mHzzx.vue'
import mProgramDetail from '../views/mProgramDetail.vue'
import mSearch from '../views/mSearch.vue'

//push 
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
//replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}
Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'phome',
  component: Home,
  redirect: "/",
  children: [{
    path: '/',
    name: 'pmain',
    component: Pmain,
  },
  {
    path: '/program',
    name: 'program',
    component: Program,
  },
  {
    path: '/programDetail/:id',
    name: 'programDetail',
    component: ProgramDetail,
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
  },
  {
    path: '/computions',
    name: 'computions',
    component: Computions,
  },
  {
    path: '/newsInfo',
    name: 'newsInfo',
    component: NewsInfo,
    redirect: "/zcfg",
    children: [{
      path: '/zcfg',
      name: "zcfg",
      component: Zcfg,
    }, {
      path: '/glzd',
      name: "glzd",
      component: Glzd,
    }, {
      path: '/ndbg',
      name: "ndbg",
      component: Ndbg,
    }, {
      path: '/sjbg',
      name: "sjbg",
      component: Sjbg,
    }, {
      path: '/xxgg',
      name: "xxgg",
      component: Xxgg,
    }]
  },
  {
    path: '/hzzx',
    name: 'hzzx',
    component: Hzzx,
    redirect: "/xmjz",
    children: [{
      path: '/xmjz',
      name: "xmjz",
      component: Xmjz,
    }]
  },
  {
    path: '/jlzx',
    name: 'jlzx',
    component: Jlzx,
    redirect: "/lyb",
    children: [{
      path: '/lyb',
      name: "lyb",
      component: Lyb,
    }, {
      path: '/hzms',
      name: "hzms",
      component: Hzms,
    }, {
      path: '/wtjd',
      name: "wtjd",
      component: Wtjd,
    }]
  },

  {
    path: '/hdzsContent/:id',
    name: "hdzsContent",
    component: HdzsContent
  },
  {
    path: '/news',
    name: 'news',
    component: News,
    redirect: "/hydt",
    children: [{
      path: '/hydt',
      name: "hydt",
      component: Hydt,
    },
    {
      path: '/hdzs',
      name: 'hdzs',
      component: Hdzs,
    }, {
      path: '/xmdt',
      name: "xmdt",
      component: Xmdt,
    }, {
      path: '/jgdt',
      name: "jgdt",
      component: Jgdt,
    }
    ]
  },
  {
    path: '/newsContent/:id',
    name: "newsContent",
    component: NewsContent
  }, {
    path: '/infoContent/:id',
    name: "infoContent",
    component: InfoContent
  },
  {
    path: '/conntect',
    name: "conntect",
    component: Conntect,
    redirect: "/gsxx",
    children: [{
      path: '/gsxx',
      name: "gsxx",
      redirect: "/jgjj",
      component: Gsxx,
      children: [{
        path: '/jgjj',
        name: "jgjj",
        component: Jgjj,
      }, {
        path: '/zc',
        name: "zc",
        component: Zc,
      }, {
        path: '/frdjz',
        name: "frdjz",
        component: Frdjz,
      }, {
        path: '/lszjj',
        name: "lszjj",
        component: Lszjj,
      }, {
        path: '/zjgwContent/:id',
        name: "zjgwContent",
        component: ZjgwContent,
      }, {
        path: '/zjgw',
        name: "zjgw",
        component: Zjgw,
      }, {
        path: '/lsh',
        name: "lsh",
        component: Lsh,
      }]
    }, {
      path: '/lxwm',
      name: "lxwm",
      component: Lxwm,
    }, {
      path: '/zzjg',
      name: "zzjg",
      component: Zzjg,
    }, {
      path: '/czlc',
      name: "czlc",
      component: Czlc,
    }]
  },
  ]
},
{
  path: '/mmain',
  name: 'mmain',
  component: mMain,
  redirect: "/mHome",
  children: [
    {
      path: "/mHome",
      name: "mHome",
      component: mHome
    },
    {
      path: "/mNews",
      name: "mNews",
      component: mNews,
      redirect: "/mhydt",
      children: [{
        path: '/mhydt',
        name: "mhydt",
        component: mHydt,
      },
      {
        path: '/mhdzs',
        name: 'mhdzs',
        component: mHdzs,
      }, {
        path: '/mxmdt',
        name: "mxmdt",
        component: mXmdt,
      }, {
        path: '/mjgdt',
        name: "mjgdt",
        component: mJgdt,
      }
      ]
    },
    {
      path: '/mNewsContent/:id',
      name: "mNewsContent",
      component: mNewsContent
    },
    {
      path: "/mJlzx",
      name: "mJlzx",
      component: mJlzx,
      redirect: "/mLyb",
      children: [{
        path: '/mLyb',
        name: "mLyb",
        component: mLyb,
      },
      {
        path: '/mWtjd',
        name: 'mWtjd',
        component: mWtjd,
      }, {
        path: '/mHzms',
        name: "mHzms",
        component: mHzms,
      }
      ]
    },
    {
      path: '/mconntect',
      name: "mconntect",
      component: mConntect,
      redirect: "/mgsxx",
      children: [{
        path: '/mgsxx',
        name: "mgsxx",
        redirect: "/mjgjj",
        component: mGsxx,
        children: [{
          path: '/mjgjj',
          name: "mjgjj",
          component: mJgjj,
        }, {
          path: '/mzc',
          name: "mzc",
          component: mZc,
        }, {
          path: '/mfrdjz',
          name: "mfrdjz",
          component: mFrdjz,
        }, {
          path: '/mlszjj',
          name: "mlszjj",
          component: mLszjj,
        }, {
          path: '/mzjgwContent/:id',
          name: "mzjgwContent",
          component: mZjgwContent,
        }, {
          path: '/mzjgw',
          name: "mzjgw",
          component: mZjgw,
        }, {
          path: '/mlsh',
          name: "mlsh",
          component: mLsh,
        }]
      }, {
        path: '/mlxwm',
        name: "mlxwm",
        component: mLxwm,
      }, {
        path: '/mzzjg',
        name: "mzzjg",
        component: mZzjg,
      }, {
        path: '/mczlc',
        name: "mczlc",
        component: mCzlc,
      }]
    },
    {
      path: '/mnewsInfo',
      name: 'mnewsInfo',
      component: mNewsInfo,
      redirect: "/mzcfg",
      children: [{
        path: '/mzcfg',
        name: "mzcfg",
        component: mZcfg,
      }, {
        path: '/mglzd',
        name: "mglzd",
        component: mGlzd,
      }, {
        path: '/mndbg',
        name: "mndbg",
        component: mNdbg,
      }, {
        path: '/msjbg',
        name: "msjbg",
        component: mSjbg,
      }, {
        path: '/mxxgg',
        name: "mxxgg",
        component: mXxgg,
      }]
    }, {
      path: '/minfoContent/:id',
      name: "minfoContent",
      component: mInfoContent
    }, {
      path: '/mProgramContent/:id',
      name: "mProgramContent",
      component: mProgramContent
    }, {
      path: '/mProgramDetail/:id',
      name: "mProgramDetail",
      component: mProgramDetail
    },
    {
      path: '/mprogram',
      name: 'mprogram',
      component: mProgram,
    },
    {
      path: '/mHzzx',
      name: 'mHzzx',
      component: mHzzx,
    },
    {
      path: '/mSearch',
      name: 'mSearch',
      component: mSearch,
    },
  ]
},
{
  path: '/cms',
  name: 'cms',
  component: Cms,
  redirect: "/userInfo",
  children: [
    {
      path: '/userInfo',
      name: 'userInfo',
      component: UserInfo
    },
    {
      path: '/pmyProgram',
      name: 'pmyProgram',
      component: pMyProgram
    },
    {
      path: '/jzList',
      name: 'jzList',
      component: JzList
    },
    {
      path: '/szList',
      name: 'szList',
      component: SzList
    },
    {
      path: '/xxwh',
      name: 'xxwh',
      component: Xxwh
    },
    {
      path: '/uploadMyProgram',
      name: 'uploadMyProgram',
      component: UploadMyProgram
    },
    {
      path: '/editMyProgram',
      name: 'editMyProgram',
      component: EditMyProgram
    },
  ]
},
{
  path: '/test',
  name: 'test',
  component: () => import('../views/Test.vue')
},
{
  path: '/login',
  name: 'login',
  component: Login
},
{
  path: '/register',
  name: 'register',
  component: Register
},
{
  path: '/*',
  name: 'notFount',
  component: NotFount
},

]

const router = new VueRouter({
  mode: 'history',
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition;
  //   } else {
  //     return { x: 0, y: 0 };
  //   }
  // },
})

export default router